import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {ReplacementRequestDto} from "../api/refereeReplacementApi";

type TSomethingState = {
  errorMessage: string;
  replacementRequest: ReplacementRequestDto,
};

export const initialReplacementRequestState: ReplacementRequestDto = {
  matchUrl: "",
  refereeEmail: "",
  replacementType: "WARSAW",
  additionalInformation: ""
};

const initialState: TSomethingState = {
  errorMessage: "",
  replacementRequest: initialReplacementRequestState,
};

export const somethingSlice = createSlice({
  name: "SOMETHING",
  initialState,
  reducers: {
    setData: <Property extends keyof TSomethingState>(
      state: TSomethingState,
      {
        payload
      }: PayloadAction<{ property: Property; value: TSomethingState[Property] }>
    ) => {
      const { property, value } = payload;
      state[property] = value;
    },
    setReplacementRequestProperty: <Property extends keyof ReplacementRequestDto>(
      state: TSomethingState,
      {
        payload
      }: PayloadAction<{ property: Property; value: ReplacementRequestDto[Property] }>
    ) => {
      const { property, value } = payload;
      state.replacementRequest[property] = value;
    }
  }
});

export const { setData, setReplacementRequestProperty } = somethingSlice.actions;

export const selectSomethingState = (state: any) => state.somethings;

export default somethingSlice.reducer;
